<template>
  <div :id="id"/>
</template>

<script setup>
import Highcharts from "@/highcharts"
import { onMounted } from "vue"
import { percent } from "@/support"

const props = defineProps({
  salaries: { type: Object, required: true },
  salary: { type: Object, required: true },
  denominator: { type: Number, required: true },
})
const id = "all_salaries"
const unknown = "#e25536"
const nonEmployed = "rgba(226, 85, 54, 0.95)"
const unemployed = nonEmployed
const noSal_employedOther = "#94A3B8"
const knownSal = "#58cbe4"

onMounted(() => {
  const series = [
    {
      ...props.salaries.employed_unknown,
      color: unknown,
      data: [percent(props.salaries.employed_unknown.value, props.denominator)],
      stickyTracking: false,
    },
    {
      ...props.salaries.employed_other,
      color: noSal_employedOther,
      data: [percent(props.salaries.employed_other.value, props.denominator)],
      stickyTracking: false,
    },
    {
      ...props.salaries.unemployed,
      color: unemployed,
      data: [percent(props.salaries.unemployed.value, props.denominator)],
      stickyTracking: false,
    },
    {
      ...props.salaries.graduate_degree,
      color: unemployed,
      data: [percent(props.salaries.graduate_degree.value, props.denominator)],
      stickyTracking: false,
    },
    {
      ...props.salaries.employed_gt,
      color: knownSal,
      data: [percent(props.salaries.employed_gt.value, props.denominator)],
      stickyTracking: false,
    },
    {
      ...props.salaries.employed_50,
      color: knownSal,
      data: [percent(props.salaries.employed_50.value, props.denominator)],
      stickyTracking: false,
    },
    {
      ...props.salaries.employed_25,
      color: knownSal,
      data: [percent(props.salaries.employed_25.value, props.denominator)],
      stickyTracking: false,
    },
    {
      ...props.salaries.employed_lt,
      color: knownSal,
      data: [percent(props.salaries.employed_lt.value, props.denominator)],
      stickyTracking: false,
    },
  ]

  const options = {
    chart: { defaultSeriesType: "bar" },
    credits: { enabled: false },
    plotOptions: { series: { stacking: "normal", groupPadding: 0, states: { hover: { enabled: false }, inactive: { opacity: .8 } } } },
    title: { text: null, style: { fontSize: "28px" } },
    xAxis: { categories: [" "] },
    yAxis: {
      min: 0,
      max: 102,
      title: {
        text: "Hover over chart to see salary ranges as a percentage of the entire class",
        style: { fontSize: "15px" },
      },
      endOnTick: false,
      startOnTick: false,
      tickInterval: 10,
      labels: { formatter() {
        return `${this.value}%`
      } },
      gridLineColor: "rgba(100, 138, 209, 0.1)",
    },
    legend: { enabled: false },
    series,
    tooltip: {
      formatter() {
        const name = `<div class='font-semibold'>${this.series.options.title || this.series.options.name}</div>`
        const number = `<div class='font-semibold text-lg'>${this.y}%</div>`
        const subtitle = this.series.options.salary || ""

        return `${number}<br/>${subtitle}<br/>${name}<br/>`
      },

    },
  }

  new Highcharts.Chart(id, options)
})
</script>
